import { isString } from 'lodash-unified'
import { buildProps, definePropType, isArray } from '@bigin/utils'
import { componentSizes } from '@bigin/constants'
import type TagInput from './tag-input.vue'

import type { ExtractPropTypes } from 'vue'

export const tagInputProps = buildProps({
  modelValue: {
    type: definePropType<string[]>(Array),
    default: [],
  },
  size: {
    type: String,
    values: componentSizes,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Enter new item end with comma (,)',
  },
  validator: {
    type: definePropType<(v: string) => boolean>(Function),
    default: () => true,
  },
  commitKey: {
    type: String,
    default: ',',
  },
  tabIndex: {
    type: Number,
    default: 0,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
} as const)
export type TagInputProps = ExtractPropTypes<typeof tagInputProps>

export const tagInputEmits = {
  'update:modelValue': (value: string[]) => isArray(value),
  changed: (value: string[]) => isArray(value),
  error: (value: string) => isString(value),
}
export type TagInputEmits = typeof tagInputEmits

export type TagInputInstance = InstanceType<typeof TagInput>
